import React from 'react';
/**
 * ラジオボタンの内側の丸コンポーネント。
 *
 * borderRadiusなどのCSSによる実装だと中心がずれることがあるためsvgで実装している。
 */
export var RadioButtonIconInner = function (props) {
    var size = props.size, innerSize = props.innerSize, className = props.className;
    var radius = size / 2;
    var innerRadius = innerSize / 2;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 " + size + " " + size, fill: "currentColor", width: size, height: size, className: className },
        React.createElement("circle", { cx: radius, cy: radius, r: innerRadius })));
};
